<!-- ***************************************************************************************************************************** -->
<!-- Form Div for Courses Explorer/Prerequisites -->
<tool-form [formTitle]="data.form_title!">
  <form
    class="example-form"
    [formGroup]="atRiskStudentForm"
    (ngSubmit)="atRiskStudentFormSubmit()"
    class="form-content"
  >
    <!-- Demo time frame select  -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select At-Risk Semester</mat-label>
      <input matInput formControlName="demo_time_frame" />
      <mat-error *ngIf="atRiskStudentForm.controls['demo_time_frame'].invalid"
        >Select Demo Time Frame</mat-error
      >
    </mat-form-field>
    <!-- Reason Dropdown Checkbox  -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select Reason</mat-label>
      <mat-select formControlName="at_risk_reasons" multiple required>
        <mat-option *ngFor="let reason of reasonList" [value]="reason">{{
          reason
        }}</mat-option>
      </mat-select>
      <mat-error *ngIf="atRiskStudentForm.controls['at_risk_reasons'].invalid"
        >Select at least one reason
      </mat-error>
    </mat-form-field>

    <!-- Course Input -->
    <div>
      <label>Why is this student at-risk:</label>
      <mat-form-field class="filter-form-field question2" appearance="fill">
        <mat-label>Leave a comment</mat-label>
        <textarea
          matInput
          placeholder="Ex. The student is at risk because..."
          name="comment"
          formControlName="comment"
          required
        ></textarea>
        <mat-error *ngIf="this.atRiskStudentForm.controls['comment'].invalid"
          >Enter a comment</mat-error
        >
      </mat-form-field>
    </div>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="!atRiskStudentForm.valid"
      (onClick)="closeDialog()"
      color="red"
    ></tool-form-action-button>

    <tool-form-action-button
      type="button"
      text="Exit"
      (onClick)="closeDialog()"
    ></tool-form-action-button>
  </form>
</tool-form>
